import script from "./UiDropdownTagsTrigger.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20object%2C%20P%20extends%20keyof%20T%2C%20L%20extends%20keyof%20T%2C%20M%20extends%20Modes%2C%20V%20extends%20T%2C%20O%20extends%20boolean"
export * from "./UiDropdownTagsTrigger.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20object%2C%20P%20extends%20keyof%20T%2C%20L%20extends%20keyof%20T%2C%20M%20extends%20Modes%2C%20V%20extends%20T%2C%20O%20extends%20boolean"

const __exports__ = script;

export default __exports__